import React from 'react';
import { Quote } from 'lucide-react';
import useAnimationOnScroll from '../../hooks/useAnimationOnScroll';
import './Testimonials.css';

const testimonials = [
    {
        quote: "I’ve been working with Cospin for about five months on a greenfield project for a commercial real estate portal. They’ve assembled a small, high-quality team with strong experience, and they’ve been consistently responsive and efficient.",
        additionalText: "Cospin has taken a true end-to-end, white-glove approach, handling everything from early concept through execution. While we’re still at the beginning of our journey together, we’re encouraged by the collaboration so far and pleased with the results to date.",
        author: "Vicki Shammah",
        title: "Founder",
        company: "TechExec LLC"
    }
];

const Testimonials = () => {
    const headerRef = useAnimationOnScroll();
    const gridRef = useAnimationOnScroll();

    return (
        <section className="testimonials-section">
            <div className="container">
                <div ref={headerRef} className="section-header underline-center animate-in">
                    <h2 className="section-title">Client Testimonials</h2>
                    <p className="section-subtitle">
                        Partnering with visionaries to build the future of PropTech
                    </p>
                </div>

                <div ref={gridRef} className="testimonials-grid animate-in">
                    {testimonials.map((testimonial, index) => (
                        <div key={index} className="testimonial-card">
                            <div className="testimonial-quote-icon">
                                <Quote size={80} strokeWidth={1} fill="currentColor" />
                            </div>
                            <div className="testimonial-body">
                                <p className="testimonial-text">{testimonial.quote}</p>
                                {testimonial.additionalText && (
                                    <p className="testimonial-text-secondary">{testimonial.additionalText}</p>
                                )}
                            </div>
                            <div className="testimonial-footer">
                                <div className="testimonial-info">
                                    <h4 className="testimonial-author">{testimonial.author}</h4>
                                    <p className="testimonial-meta">
                                        {testimonial.title} / {testimonial.company}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
